import {
  Achievement_URL,
  ChallengeAcceptList_URL,
  ChallengeHistoryList_URL,
  ChallengeSendList_URL,
  Change_Password_URL,
  claimYourPurchase_URL,
  DashBoard_URL,
  LeaderBoard_URL,
  POST_METHOD,
} from '../../Apis/api';

export const fetchDashBoardTestResult = (params) => {
  return fetch(DashBoard_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then((response) => {
    // alert(JSON.stringify(response))
    return response.json();
  });
};

export const onChangePassword = (changePasswordData) => {
  // alert(JSON.stringify(changePasswordData))

  return fetch(Change_Password_URL, {
    method: POST_METHOD,
    body: JSON.stringify(changePasswordData),
  }).then((response) => {
    // alert(JSON.stringify(response.json()))
    return response.json();
  });
};

export const fetchDashBoardDetails = params => {
  return fetch(DashBoard_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    // alert(JSON.stringify(response))
    return response.json();
  });
};

export const claimYourPurchase_API = params => {
  return fetch(claimYourPurchase_URL, {
    method: POST_METHOD,
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then(response => response.json());
};

export const fetchLeaderBoardDetails = params => {

  return fetch(LeaderBoard_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    return response.json();
  });
};

export const fetchAchievementDetails = params => {
  return fetch(Achievement_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    return response.json();
  });
};

export const fetchChallengeSendListAPI = params => {
  return fetch(ChallengeSendList_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    return response.json();
  });
};

export const fetchChallengeAcceptListAPI = params => {
  let headers = {
    'Content-Type': 'application/json',
  };

  return fetch(ChallengeAcceptList_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    return response.json();
  });
};

export const fetchChallengeHistoryListAPI = params => {
  return fetch(ChallengeHistoryList_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then(response => {
    return response.json();
  });
};


